import { readContract, getAccount } from "@wagmi/core";
import { config as wagmiConfig } from "../../wagmi.config";
import config from "../config";

const useLazyReadContractAsync = () => {
  const lazyReadContract = 
    async (abi: any, address: string, functionName: string, args: any[]) => {
      try {
        // Skip the call if address is invalid, undefined, or null
        if (!address || 
            address === '0x0000000000000000000000000000000000000000' || 
            address === 'undefined' || 
            address === 'null') {
          return null;
        }
        
        // Get the current chain ID - if wallet is connected, use that, otherwise use app's default chain
        const account = getAccount(wagmiConfig);
        const chainId = account.chainId || config.chainId;
        
        // @ts-ignore
        const result = await readContract(wagmiConfig, {
          // @ts-ignore
          abi,
          address: address as `0x${string}`,
          functionName,
          args,
          chainId, // Explicitly specify chainId so RPC can be used without wallet
        });
        return result;
      } catch (error: any) {
        // Only log contract call errors, not address validation issues
        // Skip logging for common missing address scenarios
        const isValidAddressFormat = address && 
          address.startsWith('0x') && 
          address.length === 42 &&
          address !== '0x0000000000000000000000000000000000000000';
        
        // Check if this is an expected error that should be suppressed
        const errorMessage = error?.message || String(error);
        const isExpectedError = 
          errorMessage.includes('returned no data ("0x")') || // Inactive/expired contracts
          errorMessage.includes('execution reverted: 0x') || // Contract reverted with no reason
          errorMessage.includes('Function') && errorMessage.includes('not found on ABI'); // Missing ABI function (deprecated contracts)
          
        if (isValidAddressFormat && !isExpectedError) {
          console.error("lazyReadContract", error);
        }
        return null;
      }
    }

  return { lazyReadContract };
};

export default useLazyReadContractAsync;
